import React from 'react';
import PropTypes from 'prop-types';

const LogoutIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13.997 14">
        <g fill={fill}>
            <path d="M2.514 7.737h7.431a.737.737 0 100-1.474H2.514l.951-.954A.737.737 0 002.426 4.27L.215 6.484a.737.737 0 000 1.039l2.211 2.211a.737.737 0 001.039-1.039z" />
            <path d="M13.26 0H5.155a.737.737 0 00-.737.737v3.316a.737.737 0 101.474 0V1.474h6.632v11.052H5.892V9.947a.737.737 0 10-1.474 0v3.316a.737.737 0 00.737.737h8.105a.737.737 0 00.737-.737V.737A.737.737 0 0013.26 0z" />
        </g>
    </svg>
);

LogoutIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

LogoutIcon.defaultProps = {
    width: '13.997',
    height: '14',
    fill: '#4b254e'
};

export default LogoutIcon;
